import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const noOfLiveSurveyAction = createAsyncThunk(
    'live-survey',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/live-survey?s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const noOfLiveSurveySlice = createSlice({
    name: 'live-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(noOfLiveSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(noOfLiveSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(noOfLiveSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const noOfLiveSurveyReducer = noOfLiveSurveySlice.reducer